var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"w-full text-sm p-1",attrs:{"aria-label":"Navegación secundaria"}},_vm._l((_vm.items),function(item){return _c('base-aside-nav-item',_vm._b({key:item.name,attrs:{"item":item}},'base-aside-nav-item',_vm.$attrs,false))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }